var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',_vm._g(_vm._b({staticClass:"sam-icon",class:{ 'is-loading': _vm.loading },style:(_vm.cssStyle),attrs:{"data-samora":""},domProps:{"innerHTML":_vm._s(require(`../../../icons/${_vm.icon}${_vm.filled ? '--filled' : ''}.svg`))}},'i',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }